import React, { useState } from "react";
import { IconMap, IconPin, IconCheck } from "./Icons";

const MAP_SRC =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3027.9255986520125!2d14.484310376410413!3d40.63152274253785!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x133b974cef855e4d%3A0xde520780f7602a6b!2sCasa%20Carmela%20Positano!5e0!3m2!1sen!2sit!4v1733153620072!5m2!1sen!2sit";

const POINTS = [
  {
    title: "Liparlati, old Positano",
    text: "A quiet neighbourhood above the centre, away from the crowds but minutes from everything.",
  },
  {
    title: "Bus stop 50 m away",
    text: "Local and SITA buses to Sorrento and Amalfi leave from just outside the door.",
  },
  {
    title: "Walk to Spiaggia Grande",
    text: "Steps nearby lead down to Piazza dei Mulini and the main beach.",
  },
  {
    title: "Two minimarkets steps away",
    text: "Everything you need for breakfast or a home-cooked dinner.",
  },
];

export const WhereWeAre = ({ consent, onAllowMap }) => {
  const [requested, setRequested] = useState(false);
  const canLoad = consent?.external || requested;

  return (
    <section className="section section--sand" id="location">
      <div className="container">
        <div className="location">
          <div>
            <div className="section-head section-head--left">
              <span className="eyebrow">Where we are</span>
              <h2>In the heart of Positano</h2>
              <hr className="rule" />
              <p>
                Casa Carmela sits in Liparlati, one of Positano's oldest districts — a peaceful
                retreat that keeps the town's vibrant centre within easy reach.
              </p>
            </div>

            <ul className="location__points">
              {POINTS.map((p) => (
                <li className="location__point" key={p.title}>
                  <IconCheck />
                  <div>
                    <strong>{p.title}</strong>
                    <span>{p.text}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="map-frame">
            {canLoad ? (
              <iframe
                src={MAP_SRC}
                title="Map showing Casa Carmela in Positano"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            ) : (
              <div className="map-placeholder">
                <IconMap width={40} height={40} />
                <p>
                  The map is provided by Google and would send data to Google before you interact
                  with it.
                </p>
                <button
                  type="button"
                  className="btn btn--primary btn--sm"
                  onClick={() => {
                    setRequested(true);
                    if (onAllowMap) onAllowMap();
                  }}
                >
                  <IconPin width={16} height={16} />
                  Load map
                </button>
                <a
                  className="btn btn--ghost btn--sm"
                  href="https://www.google.com/maps?q=V.+G.+Marconi,+196,+84017+Positano+SA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open in Google Maps
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhereWeAre;
